import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./components/Login";
import Quotations from "./pages/Quotations";
import AddQuotation from "./pages/AddQuotation";
import Orders from "./pages/Orders";
import AddOrders from "./pages/AddOrder";
import Jobsheets from "./pages/Jobsheets";
import AddStoreGroup from "./pages/AddStoreGroup";
import AddMatLocation from "./pages/AddMatLocation";
import AddMaterial from "./pages/AddMaterial";
import Material from "./pages/Material";
import StockInPage from "./pages/StockInPage";
import StockOutPage from "./pages/StockOutPage";
import CurrentStock from "./pages/CurrentStock";
import Transactions from "./pages/Transactions";
import UserUpdates from "./pages/UserUpdates";
import Users from "./pages/Users";
import Msds from "./pages/Msds";
import Icp from "./pages/Icp";
import Specs from "./pages/Specs";
import Reports from "./pages/Reports";
import DiecutList from "./pages/DiecutList";
import AddDiecut from "./pages/AddDiecut";
import RequestMaterialPage from "./pages/RequestMaterialPage";
import ApproveMaterialPage from "./pages/ApproveMaterialPage";
import ApproveStockInPage from "./pages/ApproveStockInPage";
import QCCheckingPage from "./pages/QCCheckingPage";
import QCShipmentListPage from "./pages/QCShipmentListPage";
import FinishedGoodsPage from "./pages/FinishedGoodsPage";
import RequestListPage from "./pages/RequestListPage";
import RequestRibbonFGPage from "./pages/RequestRibbonFGPage";
import UserLevelPage from "./pages/UserLevelPage";
import PagePermissionsPage from "./pages/PagePermissionsPage";
import FormNumbersPage from "./pages/FormNumbersPage";
import NewJobsheetPage from "./pages/NewJobsheetPage";
import AlignJobsheetPage from "./pages/AlignJobsheetPage";
import CustomerListPage from "./pages/CustomerListPage";
import MaterialManagementPage from "./pages/MaterialManagementPage";
import OperatorQCPage from "./pages/OperatorQCPage";
import ProductionAssignmentPage from "./pages/ProductionAssignmentPage";
import ProductionReportPage from "./pages/ProductionReportPage";
import ClientReportPage from "./pages/ClientReportPage";
import YearlyChartPage from "./pages/YearlyChartPage";
import { Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/home" element={<Navigate to="/dashboard" replace />} />
          <Route path="/quotation" element={<Quotations />} />
          <Route path="/quotation/add" element={<AddQuotation />} />
          <Route path="/orderlist" element={<Orders />} />
          <Route path="/addOrder" element={<AddOrders />} />
          <Route path="/addstoregroup" element={<AddStoreGroup />} />
          <Route path="/addlocation" element={<AddMatLocation />} />
          <Route path="/jobsheet" element={<Jobsheets />} />
          <Route path="/addmaterial" element={<AddMaterial />} />
          <Route path="/materials" element={<Material />} />
          <Route path="/stockin" element={<StockInPage />} />
          <Route path="/stockout" element={<StockOutPage />} />
          <Route path="/currentstock" element={<CurrentStock />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/users" element={<Users />} />
          <Route path="/msds" element={<Msds />} />
          <Route path="/icp" element={<Icp />} />
          <Route path="/users/update" element={<UserUpdates />} />
          <Route path="/specs" element={<Specs />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/diecut-list" element={<DiecutList />} />
          <Route path="/add_diecut" element={<AddDiecut />} />
          <Route path="/request_mat" element={<RequestMaterialPage />} />
          <Route path="/approve_mat" element={<ApproveMaterialPage />} />
          <Route path="/approve_stockin" element={<ApproveStockInPage />} />
          <Route path="/qc_checking" element={<QCCheckingPage />} />
          <Route path="/qc_shipment_list" element={<QCShipmentListPage />} />
          <Route path="/finished_goods" element={<FinishedGoodsPage />} />
          <Route path="/request-list" element={<RequestListPage />} />
          <Route path="/request-ribbon-fg" element={<RequestRibbonFGPage />} />
          <Route path="/user_level" element={<UserLevelPage />} />
          <Route path="/page_permissions" element={<PagePermissionsPage />} />
          <Route path="/form_numbers" element={<FormNumbersPage />} />
          <Route path="/jobsheet/add" element={<NewJobsheetPage />} />
          <Route path="/jobsheet/align" element={<AlignJobsheetPage />} />
          <Route path="/quotation/customers" element={<CustomerListPage />} />
          <Route path="/jobsheet/material" element={<MaterialManagementPage />} />
          <Route path="/jobsheet/operator-qc" element={<OperatorQCPage />} />
          <Route path="/orders/production-assignment" element={<ProductionAssignmentPage />} />
          <Route path="/jobsheet/report" element={<ProductionReportPage />} />
          <Route path="/reporting/client" element={<ClientReportPage />} />
          <Route path="/reporting/yearly-chart" element={<YearlyChartPage />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        theme="colored"
      />
    </div>
  );
}

export default App;
